export const Config = {
    // DEV:
    // HOST_URL: "http://localhost:80"
    // PROD:
    HOST_URL: "https://tms.proga.space"
}
